/**
 * Need to keep these names outside the component
 * for component type checking in SelectList
 * to avoid circular dependency issue Dropdown -> SelectList -> Dropdown
 */
const DropdownItemDisplayName = 'DropdownItem';
const DropdownItemGroupDisplayName = 'DropdownItemGroup';

export { DropdownItemDisplayName as D, DropdownItemGroupDisplayName as a };
//# sourceMappingURL=displayNames-27272ef3.js.map
